/*
 * Handler for global subscribe form
 */

const $ = window.jQuery;
const $html = $("html");
const emailInputSelector = ".js--subscribe-email";
const activeClass = "is--active";
const gaCategory = "Newsletter";

/**
 * Returns the position of the form: header, footer, interrupter
 */
function getGAlabel($el) {
  var label = 'Interrupter';

  if ( $el.parents('#menu-main').length ) {
    label = 'Header';
  }
  else if ( $el.parents('footer.footer').length ) {
    label = 'Footer';
  }

  return label;
}

/*
 * Open Form when focusing the email field
 */
$(document).on("focus", emailInputSelector, function() {
  var $t = $(this);

  // For main menu, we also want to scroll to the bottom of the form after expanding
  if ($t.parents("#menu-main").length) {
    $("#menu-main")
      .stop()
      .animate({
          scrollTop: $("#menu-main")[0].scrollHeight
        }, 800);
  }

  $(window).trigger('ga.event', {
    category: gaCategory,
    action: 'Open',
    label: getGAlabel($t)
  });
});

/*
 * Close Form when clicking anywhere outside subscribe module
 */
$html.on("click", function(e) {
  var $target = $(e.target),
    subscribeFormClass = ".subscribe.is--active";

  if (
    !$target.is(subscribeFormClass) &&
    !$target.parents(subscribeFormClass).length
  ) {
    $(subscribeFormClass)
      .removeClass(activeClass)
      .find("[type=email]")
      .blur();
  }
});
